<template>
  <timeline v-if="isEmptyTimeline" class="article-timeline no-article-swipe" :timelineConfig="timelineConfig" :nid="nid" :isOverlay="false"></timeline>
</template>

<script>
  import Timeline from 'components/node/person/Timeline.vue'
  import TimelineMixin from 'components/mixins/timeline'

  export default {
    name: 'article-timeline',
    mixins: [TimelineMixin],
    data() {
      return {
        timelineConfig: {
          scale_factor: 1,
          timenav_height_percentage: 35,
          timenav_mobile_height_percentage: 30,
          slide_padding_lr: 50,
        },
      }
    },
    props: {
      nid: {
        type: [String, Number],
        required: true,
      },
      isOverlay: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      node() {
        return this.$store.getters.node(this.nid)
      },
    },
    components: {
      Timeline,
    },
  }
</script>

<style lang="scss" scoped>
  .article-timeline {
    @include respond-to('desktop') {
      margin-left: rem-calc(-55);
      margin-right: rem-calc(-55);
    }

    @include respond-to('mobile') {
      margin-left: rem-calc(-20);
      margin-right: rem-calc(-20);
    }

    background-color: $timeline-light-gray;
    margin-bottom: rem-calc(40);
  }
</style>

<style lang="scss">
  .article-timeline {

    .timeline-pane {
      border-image: linear-gradient(to right, $rose, $waterspout);
      border-width: rem-calc(1) 0 0;
      border-image-slice: 1;
      border-style: solid;
    }

    .tl-text-content-container {
      max-width: rem-calc(360);
      color: $timeline-dark-jungle-green;
      .tl-headline-date {
        font-weight: 600;
      }
      h2.tl-headline,
      .tl-headline {
        @include respond-to('desktop') {
          width: auto;
        }
      }
    }

    .tl-timenav {
      background-color: $timeline-gray;
      &:after {
        background-image: url('/static/svg/icon_timeline_triangle_light.svg');
      }
    }

    .tl-storyslider {
      &:before {
        background-color: $timeline-gray;
        border-top: rem-calc(1) solid $timeline-darker-gray;
      }
    }

    .tl-timemarker {
      &.tl-timemarker-active {
        .tl-timemarker-content {
          background-color: $rose;
          &:after {
            border-color: $rose transparent transparent transparent;
          }
        }
        .tl-headline {
          color: $white;
        }
        .timeline-marker-line {
          width: rem-calc(2);
        }
      }

      .tl-timemarker-content {
        background-color: $timeline-darker-gray;
        &:after {
          border-color: $timeline-darker-gray transparent transparent transparent;
        }
      }
    }

    .tl-media-shadow {
      box-shadow: none;
    }

    .tl-slide {
      &:not(.tl-slide-text-only) {
        .tl-slide-content-container {
          .tl-text {
            padding-top: rem-calc(5);
          }
        }
      }
      .tl-slide-content-container {
        .tl-slide-content {
          .tl-media {
            min-width: 0;
            width: rem-calc(310);
            height: rem-calc(180);
            margin-right: rem-calc(30);
            display: table-cell
          }
        }
      }
    }

    .timeline-marker-line {
      &,
      &:after {
        background-color: $timeline-dark-gray;
      }
    }

    .tl-slidenav-next,
    .tl-slidenav-previous {

      @include respond-to('mobile') {
        opacity: 0;
      }

      .tl-slidenav-title,
      .tl-slidenav-description {
        display: none;
      }
    }

    .tl-slidenav-next {
      .tl-slidenav-icon {
        &:before {
          background-image: url('/static/svg/icon_arrow_right_8bit_rose.svg');
        }
      }
    }
    .tl-slidenav-previous {
      .tl-slidenav-icon {
        &:before {
          background-image: url('/static/svg/icon_arrow_left_8bit_rose.svg');
        }
      }
    }

    .tl-timeaxis-tick-text {
      color: $rose;
    }

    .tl-timeaxis-background {
      background: $timeline-light-gray;
      border-width: 0;
      border-top: rem-calc(1) solid $timeline-dark-gray;
    }

    // Desktop theme
    .tl-layout-landscape {
      .tl-slide {
        padding-left: rem-calc(0);
        padding-right: rem-calc(0);
      }
    }
  }
</style>


// WEBPACK FOOTER //
// ArticleTimeline.vue?42ec32cc